export const issueVouchers = {
  title: 'Issue vouchers',
  titles: {
    create: 'Create issue voucher',
    edit: 'Edit issue voucher',
    detail: 'Issue voucher detail',
    list: 'Issue voucher list',
    addQuick: 'Quick add',
  },
  sections: {
    linkage: 'Warehouse, customer & people',
    note: 'Notes',
    detail: 'Voucher information',
  },
  fields: {
    code: 'Voucher code',
    warehouse: 'Warehouse',
    customer: 'Customer',
    createdBy: 'Created by',
    deliverer: 'Delivered by',
    confirmer: 'Confirmed by',
    status: 'Status',
    batches: 'Batches',
    note: 'Note',
    actions: 'Actions',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
  },
  statusValues: {
    PENDING: 'Pending',
    IN_PROGRESS: 'In progress',
    DELIVERED: 'Delivered',
    CANCELLED: 'Cancelled',
  },
  actions: {
    confirmProgress: 'Confirm progress',
    confirmDelivered: 'Mark delivered',
  },
  messages: {
    noData: 'No data',
  },
  filter: {
    placeholder: 'Search by code, warehouse, customer...',
  },
  validation: {
    atLeastOneBatch: 'Select at least one batch',
  },
}
